import React from "react";
import LinearProgress from "@mui/material/LinearProgress";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useLoader } from "./LoaderContext";
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';

interface LoaderOverlayProps {
    active: boolean;
    text: string; // Add the text prop
}

const LoaderOverlay: React.FC<LoaderOverlayProps> = ({ active, text }) => {
    const { showLoader,warningText, hideLoader } = useLoader();

    const navigate = useNavigate();

    const handleButtonClick = () => {
        hideLoader();
        navigate("/dashboard"); // Route to the /about page
    };
    const handleViewRuleBook = () => {
        hideLoader();
        navigate("/rulebook"); // Route to the /about page
    }

    if (!active) return null;
    return (
        <div className="loader-overlay">
            <div className="loader-content">
                <LinearProgress
                    style={{
                        height: "12px",
                        width: "313px",
                        backgroundColor: "#343333",
                        borderRadius: "4px",
                        marginLeft: "auto",
                        marginRight: "auto",
                    }}
                />
                {"analyze" == text && (
                    <>
                        <h2>Analysing rules...</h2>
                        <div className="loader-desc">
                            Rulebook will be uploaded shortly...
                        </div>
                        {warningText && (
                            <>
                            <div><label> Validation Warning(s) : </label></div>
                            <div
                                style={{
                                marginTop: "16px",
                                color: "#FFCC00",
                                fontWeight: 500,
                                textAlign: "center",
                                }}
                            >
                                {warningText}
                            </div>
                            </>
                            )}
                    </>
                )}
                {"validate" == text && (
                    <>
                        <h2>Validating files..</h2>
                        <div className="loader-desc">
                            Rulebook will be uploaded shortly. Please wait while we validate the uploaded files...
                        </div>
                    </>
                )}
                {"reValidate" == text && (
                    <>
                        <h2>Re-validating rules...</h2>
                        <div className="loader-desc">
                            Rulebook will be generated shortly. Please wait while we re-validating your updated records...
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default LoaderOverlay;

